module.exports = require("reflect-metadata");;